import React, { useContext, useEffect, useState } from "react";

// Services
import AuthenticationService from "../../services/AuthenticationService";

// Views

// UI
import { LinearProgress, makeStyles, Typography } from "@material-ui/core";

// Utils
import SimpleAlert from "../../components/Alert/SimpleAlert";
import BackButton from "../../components/Button/BackButton";
import { defaultSearchFilter, VERTICALS_LIST } from "../../utils/constants";
import { filterTripletsByUserLevel, getUserVisibilityLevel } from "../../utils";
import _ from "lodash";
import ScrollToTop from "../../components/Button/ScrollToTop";
import HomeCardsSection from "./HomeCardsSection";
import FaqSearchBar from "./FaqsSearchBar";
import FaqDetailView from "./Detail/DetailFaqView";
import VerticalDetailView from "./Detail/DetailVerticalView";
import SearchResultView from "./SearchResult/SearchResultView";
import OpenTicketDialog from "./Ticket management/OpenTicketDialog";
import AddFaqDialog from "./AddFaqDialog";
import useCountryAxiosInstance from "../../hooks/useCountryAxiosInstance";
import { filterHitsToPreventFlooding } from "./utils";
import { useHistory } from "react-router-dom";
import CountryContext from "../../CountryContext";
import Button from "../../ui-components/Button";
import apiRequest from "../../services/apiRequest";
import {PRIVILEGED_ROLES} from "../../constants";

const useStyles = makeStyles((theme) => ({
  div: {
    marginTop: `${theme.spacing(2)}px`,
  },
  title: {
    width: "100%",
    marginTop: "25px",
    marginBottom: "15px",
    textAlign: "center",
  },
  subtitle: {
    marginBottom: 0,
  },
  addButton: {
    margin: 20,
  },
  submitRight: {
    position: "absolute",
    right: 25,
    margin: theme.spacing(3, 0, 2),
  },
  dialogPaper: {
    minHeight: "80vh",
    maxHeight: "80vh",
  },
}));

//TODO: gestione ticket riattivare
//TODO: apri una segnalazione riattivare
//TODO: Spostare il json dei temi in una tabella a DB, mettendo tutti i referenti a 1

//TODO: gestione temi da finire
//TODO: lettura immagini il bucket precedente era pubblico

const Faqs = (props) => {
  const classes = useStyles();
  const userData = AuthenticationService.getUserData();
  const apiRequestCountry = useCountryAxiosInstance();
  const history = useHistory();
  const { country } = useContext(CountryContext);

  //Objects

  const [object] = useState("faqs");
  const [faqs, setFaqs] = useState();
  const [searchResult, setSearchResult] = useState();
  const [triplets, setTriplets] = useState();
  const [tripletsSearchResult, setTripletsSearchResult] = useState();
  const [selectedSearchTab, setSelectedSearchTab] =
    useState(defaultSearchFilter);

  const [top5Themes, setTop5Themes] = useState();
  const [adminsOptions, setAdminsOptions] = useState();

  const [apiResponse, setApiResponse] = useState();
  const [loading, setLoading] = useState(false);

  const [detailedFaq, setDetailedFaq] = useState();
  const [vmtDetail, setVmtDetail] = useState();
  const [scrollToObject, setScrollToObject] = useState();
  const [editableFaq, setEditableFaq] = useState();

  const [navigationStatus, setNavigationStatus] = useState("home");
  const [searchValue, setSearchValue] = useState("");

  // Manage link to specific question
  const [linkId] = useState(props.match.params.id);
  useEffect(() => {
    if (linkId && faqs && triplets) {
      setDetailedFaq(_.find(faqs, (i) => i._id === linkId));
      setNavigationStatus("faq_detail");
    }
  }, [linkId, faqs, triplets]);

  if (props.location.state && props.location.state.home) {
    setNavigationStatus("home");
    setSelectedSearchTab(defaultSearchFilter);
    props.location.state = {};
  }

  //eslint-disable-next-line
  const navigateTo = (target) => {
    history.push(`/${country.code}/kerakoll_assistant${target}`);
  };

  //Toggles
  const [showNewFaqDialog, setShowNewFaqDialog] = useState(false);
  const [showTicketDialog, setShowTicketDialog] = useState(false);
  const [ticketSpecificFaq, setTicketSpecificFaq] = useState(undefined);

  // Handle Alert options
  const ALERT_INIT_STATE = {
    open: false,
    type: "",
    message: "",
  };
  const [alert, setAlert] = useState(ALERT_INIT_STATE);

  const toggleNewFaqDialog = () => {
    setShowNewFaqDialog(!showNewFaqDialog);
  };

  const toggleTicketDialog = (specificFaq = undefined) => {
    if (specificFaq && specificFaq._id) {
      setTicketSpecificFaq(specificFaq);
    } else {
      setTicketSpecificFaq(undefined);
    }
    setShowTicketDialog(!showTicketDialog);
  };

  const openAlert = (type, message) => {
    setAlert({
      open: true,
      type,
      message,
    });
  };

  const toggleAlert = () => {
    setAlert({
      ...alert,
      open: !alert.open,
    });
  };


  useEffect(() => {
    if (PRIVILEGED_ROLES.includes(userData.role_type) && adminsOptions === undefined) {
      getAdminsForReference();
    }
  }, [adminsOptions]); // eslint-disable-line react-hooks/exhaustive-deps

  const getAdminsForReference = () => {
    apiRequest
      .post("users/with_role", { role: [...PRIVILEGED_ROLES, "field"] })
      .then((res) => {
        setAdminsOptions(res);
      })
      .catch((err) => {
        console.log("err", err);
      });

    // ApiService.getEntries('users/admin')
    //   .then((response) => {
    //     console.log('getAdminsForReference response', response)
    //     setAdminsOptions(response)
    //   })
    //   .catch((err) => console.log(err))
  };

  function createDictFromES(faqs, fromSearchResult = false) {
    if (!fromSearchResult) {
      faqs.vmt.forEach(function (item) {
        item.questions = faqs["hits"].filter(function (el) {
          return (
            el._source.vertical === item.vertical &&
            el._source.macrotema === item.macrotema &&
            el._source.tema === item.tema
          );
        });
        item.questions.sort((a, b) => b._source.views - a._source.views);
        item.total_views = item.questions.reduce(
          (a, b) => a + (b["_source"]["views"] || 0),
          0
        );
      });

      faqs.vmt = faqs.vmt.filter(function (obj) {
        if (
          obj.vertical !== null &&
          obj.macrotema !== null &&
          obj.tema !== null
        ) {
          return obj;
        } else return false;
      });

      faqs.vmt.sort(
        (a, b) =>
          a.vertical.localeCompare(b.vertical) ||
          a.macrotema.localeCompare(b.macrotema) ||
          a.tema.localeCompare(b.tema)
      );
      // console.log('faqs.vmt', faqs.vmt)
      faqs.vmt = filterTripletsByUserLevel(faqs.vmt, userData);
      setTriplets(faqs.vmt);
      let top5Array = JSON.parse(JSON.stringify(faqs.vmt));
      setTop5Themes(
        top5Array.sort((a, b) => b.total_views - a.total_views).slice(0, 5)
      );
    } else {
      let clonedArray = JSON.parse(JSON.stringify(triplets));
      clonedArray.forEach(function (item) {
        item.questions = faqs["hits"].filter(function (el) {
          return (
            el._source.vertical === item.vertical &&
            el._source.macrotema === item.macrotema &&
            el._source.tema === item.tema
          );
        });
        item.total_views = item.questions.reduce(
          (a, b) => a + (b["_source"]["views"] || 0),
          0
        );
      });
      //
      let tempTriplets = clonedArray.filter(function (obj) {
        if (obj.total_views > 0) {
          return obj;
        } else return false;
      });
      tempTriplets = filterTripletsByUserLevel(tempTriplets, userData);
      setTripletsSearchResult(tempTriplets);
    }
    setLoading(false);
  }

  //eslint-disable-next-line
  const fetchFaqs = async (showFaqAfterFetchingFromId = undefined) => {
    setLoading(true);
    apiRequestCountry.get("/assistant/get_all").then((result) => {
      // console.log('fetchSalesOrder result', result)
      setFaqs(result["hits"]);
      // Se showFaqAfterFetchingFromId è settato vuol dire che una domanda è appena stata aggiunta/modificata
      // devo quindi recuperare
      if (showFaqAfterFetchingFromId) {
        let faqToShow = result["hits"].find(
          (x) => x._id === showFaqAfterFetchingFromId.toString()
        );
        if (faqToShow) {
          setDetailedFaq(faqToShow);
          setNavigationStatus("faq_detail");
        }
      }
      setApiResponse(result);
    });
  };

  const searchInFaqs = async (searchString) => {
    setLoading(true);
    apiRequestCountry
      .post("/assistant/search", { search_term: searchString })
      .then((result) => {
        result["hits"] = filterHitsToPreventFlooding(result["hits"]);
        setSearchResult(result["hits"]);
        createDictFromES(result, true);
        setNavigationStatus("search_result");
      })
      .catch((error) => {
        console.log(error);
        openAlert("error", "Impossibile creare la domanda!");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const scrollToElement = (element) => {
    if (scrollToObject) {
      element = scrollToObject;
      if (document.getElementById(element)) {
        let offsetTop = document.getElementById(element).offsetTop;
        console.log(
          "document.getElementById(element).offsetTop",
          document.getElementById(element).offsetTop
        );
        const main = document.getElementById("main");
        main.scroll({
          top: offsetTop - 100,
          behavior: "smooth",
        });
      }
    }
  };

  const handleBackNavigation = () => {
    switch (navigationStatus) {
      case "faq_detail": {
        if (vmtDetail) {
          //Se VmtDetail è settato vuol dire che si è arrivati al dettaglio domanda dalla lista domande per vertical
          setNavigationStatus("vertical_detail");
        } else {
          setNavigationStatus("home");
          setSelectedSearchTab(defaultSearchFilter);
        }
        break;
      }
      case "faq_detail_from_search": {
        setNavigationStatus("search_result");
        break;
      }
      case "vertical_detail": {
        setNavigationStatus("home");
        setSelectedSearchTab(defaultSearchFilter);
        break;
      }
      case "search_result": {
        // se non è stato imposto nessun filtro vertical sulla ricerca il tasto indietro riporta alla home
        // disattiva il filtro altrimenti
        if (selectedSearchTab === defaultSearchFilter) {
          setNavigationStatus("home");
        } else {
          setSelectedSearchTab(defaultSearchFilter);
        }
        break;
      }
      default:
        break;
    }
  };

  //eslint-disable-next-line
  useEffect(fetchFaqs, [object]);
  useEffect(() => {
    // console.log('useEffect createDictFromES(apiResponse)', apiResponse)
    if (apiResponse) {
      createDictFromES(apiResponse);
    }
  }, [apiResponse]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(scrollToElement, [scrollToObject]);

  // Views
  const Title = () => (
    <>
      <Typography className={classes.title} variant="h6">
        Ciao, sono Kerakoll Assistant! Hai bisogno di aiuto?
      </Typography>
    </>
  );

  const Header = () => {
    return (
      <>
        <LinearProgress
          style={{
            visibility: loading ? "visible" : "hidden",
            marginBottom: 5,
          }}
        />
        <div>
          {faqs && (
            <FaqSearchBar
              faqs={faqs}
              searchInFaqs={searchInFaqs}
              top5Themes={top5Themes}
              searchValue={searchValue}
              setSearchValue={setSearchValue}
              setDetailedFaq={setDetailedFaq}
              setSelectedSearchTab={setSelectedSearchTab}
              setNavigationStatus={setNavigationStatus}
            />
          )}
          {navigationStatus !== "home" && (
            <BackButton
              handleBackNavigation={handleBackNavigation}
            ></BackButton>
          )}
        </div>
      </>
    );
  };

  const Content = () => {
    return (
      <>
        {!loading && triplets && navigationStatus === "home" && (
          <>
            <HomeCardsSection
              triplets={triplets}
              faqs={faqs}
              verticals={VERTICALS_LIST}
              faqSelection={setDetailedFaq}
              vmtSelection={setVmtDetail}
              setNavigationStatus={setNavigationStatus}
              setScrollToObject={setScrollToObject}
            ></HomeCardsSection>
            {!loading && (
              <div className="mt-12 pb-4 flex justify-between">
                {PRIVILEGED_ROLES.includes(userData.role_type) && (
                  <>
                    <Button
                      styleType="green"
                      onClick={() => {
                        console.log("setting empty editable faq");
                        setEditableFaq(undefined);
                        toggleNewFaqDialog();
                      }}
                    >
                      Aggiungi domanda
                    </Button>

                    <Button
                      styleType="empty"
                      onClick={() => navigateTo("/themes")}
                    >
                      Gestione Temi
                    </Button>


                    {/*<Button*/}
                    {/*  styleType="empty"*/}
                    {/*  onClick={() => (window.location = "/faqs/ticket")}*/}
                    {/*>*/}
                    {/*  Gestione Ticket*/}
                    {/*</Button>*/}
                  </>
                )}
                {/*<Button*/}
                {/*  styleType="green"*/}
                {/*  onClick={() => {*/}
                {/*    toggleTicketDialog();*/}
                {/*  }}*/}
                {/*>*/}
                {/*  Apri una segnalazione*/}
                {/*</Button>*/}
              </div>
            )}
          </>
        )}
        {navigationStatus === "faq_detail" && !detailedFaq && (
          <div key="no_result_label" style={{ margin: 40 }}>
            <Typography variant="h6" align="center">
              Il contenuto richiesto non è più disponibile
            </Typography>
          </div>
        )}
        {detailedFaq &&
          (navigationStatus === "faq_detail" ||
            navigationStatus === "faq_detail_from_search") && (
            <FaqDetailView
              detailedFaq={detailedFaq}
              triplets={triplets}
              setScrollToObject={setScrollToObject}
              setDetailedFaq={setDetailedFaq}
              vmtSelection={setVmtDetail}
              setEditableFaq={setEditableFaq}
              toggleNewFaqDialog={toggleNewFaqDialog}
              toggleTicketDialog={toggleTicketDialog}
              setNavigationStatus={setNavigationStatus}
              fetchFaqs={fetchFaqs}
              isAdmin={PRIVILEGED_ROLES.includes(userData.role_type)}
              userData={userData}
              openAlert={openAlert}
            />
          )}
        {vmtDetail && navigationStatus === "vertical_detail" && (
          <VerticalDetailView
            selectedVertical={vmtDetail}
            triplets={triplets}
            faqSelection={setDetailedFaq}
            setScrollToObject={setScrollToObject}
            vmtSelection={setVmtDetail}
            fetchFaqs={fetchFaqs}
            setEditableFaq={setEditableFaq}
            toggleNewFaqDialog={toggleNewFaqDialog}
            setNavigationStatus={setNavigationStatus}
            isAdmin={PRIVILEGED_ROLES.includes(userData.role_type)}
            userData={userData}
            openAlert={openAlert}
          />
        )}
        {searchResult && navigationStatus === "search_result" && (
          <SearchResultView
            searchResult={searchResult}
            tripletsSearchResult={tripletsSearchResult}
            selectedSearchTab={selectedSearchTab}
            setSelectedSearchTab={setSelectedSearchTab}
            faqSelection={setDetailedFaq}
            setScrollToObject={setScrollToObject}
            vmtSelection={setVmtDetail}
            fetchFaqs={fetchFaqs}
            setEditableFaq={setEditableFaq}
            toggleNewFaqDialog={toggleNewFaqDialog}
            setNavigationStatus={setNavigationStatus}
            isAdmin={PRIVILEGED_ROLES.includes(userData.role_type)}
            userData={getUserVisibilityLevel(userData)}
          />
        )}
        {triplets && (
          <>
            <AddFaqDialog
              open={showNewFaqDialog}
              toggleOpen={toggleNewFaqDialog}
              openAlert={openAlert}
              triplets={triplets}
              fetchFaqs={fetchFaqs}
              editableFaq={editableFaq}
              adminsOptions={adminsOptions}
            />
            <OpenTicketDialog
              open={showTicketDialog}
              toggleOpen={toggleTicketDialog}
              openAlert={openAlert}
              triplets={triplets}
              ticketSpecificFaq={ticketSpecificFaq}
            />
          </>
        )}

        <SimpleAlert alert={alert} toggleAlert={toggleAlert} />
      </>
    );
  };

  // Render

  return (
    <>
      <ScrollToTop />
      {!linkId && navigationStatus === "home" && <Title />}
      <Header />
      <Content />
    </>
  );
};

export default Faqs;
